import { CollectionLockupFragment } from "@opensea/app-kit"
import { graphql } from "@opensea/graphql"

export const ProfileCollectionItemFragment = graphql(
  `
    fragment ProfileCollectionItem on Collection {
      slug
      imageUrl
      floorPrice {
        id
        pricePerItem {
          token {
            unit
            symbol
          }
          usd
        }
      }
      topOffer {
        id
        pricePerItem {
          token {
            unit
            symbol
          }
          usd
        }
      }
      ...CollectionLockup
    }
  `,
  [CollectionLockupFragment],
)
